import { Buffer } from "buffer";

import { generateTraceContext } from "@audacia-hq/shared/utils";

import client from "../axios";
import config from "../config";

/**
 * Upload a file to Storage-API
 * @param file file to upload
 * @param context folder to upload in
 * @param share list of uid to give access to the file
 */
const uploadFile = async (file: File, filename:string, context: string, shared?: string[]): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file, filename);
  formData.append("context", context);
  if (shared) formData.append("shared", JSON.stringify(shared));
  const res = await client.post<{ url: string; }>(
    `${config.apiBaseHost}/storage-api/v1/file/private`,
    formData,
    {
      withCredentials: true,
      headers: {
        "x-application-context": "idealvoyance",
        traceparent: generateTraceContext(),
      },
    },
  );
  return res.data.url;
};

const getPrivateFile = (path: string, signal?: AbortSignal) => client.get(`${config.apiBaseHost}/storage-api/v1/file/${path}`, {
  responseType: "arraybuffer",
  withCredentials: true,
  headers: { traceparent: generateTraceContext() },
  signal,
}).then((res) => `data:${
  res.headers["content-type"]
};base64,${Buffer.from(res.data, "binary").toString("base64")}`);

export {
  uploadFile,
  getPrivateFile,
};
